export const BASEURL = "https://api.mms.chanels.io/";

export const APIHeaders = {
  Version: "0.1",
  "content-type": "application/json",
};
